const DEFAULT_VALIDATION_LABELS: Record<string, string> = {
  product: '商品基本資料',
  name_zh: '商品中文名稱',
  name_en: '商品英文名稱',
  brand: '品牌',
  manufacturer: '製造商',
  origin: '原產地',
  product_category_code: '商品分類',
  specification: '商品規格',
  unit: '銷售單位',
  tax_included_price: '含稅進價',
  suggested_retail_price: '建議售價',
  barcodes: '國際條碼',
  attachments: '附件',
};

export function humanizeValidationMessage(
  field: string,
  message: string,
  configuredLabel?: string,
): string {
  const label = configuredLabel || DEFAULT_VALIDATION_LABELS[field] || field;
  const normalized = message.trim();
  if (field === 'product' && /Expected object, received (null|undefined)/i.test(normalized))
    return '商品基本資料尚未正確建立，請重新整理頁面後再試；若問題持續發生，請聯繫系統管理員。';
  if (/^Required$/i.test(normalized) || /must contain at least/i.test(normalized))
    return `請填寫${label}。`;
  if (/Invalid enum value|Invalid literal value/i.test(normalized)) return `請選擇有效的${label}。`;
  if (/Expected (string|number|boolean|array|object)/i.test(normalized))
    return `請確認${label}格式正確。`;
  if (/^Invalid input$/i.test(normalized) || /^Invalid date/i.test(normalized))
    return `請確認${label}格式正確。`;
  if (/String must contain at most|Number must be/i.test(normalized))
    return `${label}內容格式不正確。`;
  return message;
}

export function sanitizeValidationDetails(details: unknown): unknown {
  if (!details || typeof details !== 'object' || Array.isArray(details)) return details;
  const record = details as { fieldErrors?: Record<string, unknown> };
  if (!record.fieldErrors || typeof record.fieldErrors !== 'object') return details;
  return {
    ...record,
    fieldErrors: Object.fromEntries(
      Object.entries(record.fieldErrors).map(([field, messages]) => [
        field,
        (Array.isArray(messages) ? messages : [messages]).map((message) =>
          humanizeValidationMessage(field, String(message ?? '')),
        ),
      ]),
    ),
  };
}
